import React from 'react';
import CapRow from '../../CapRow';
import CapIcon from '../../CapIcon';

import { rootClsPrefix as clsPrefix } from '../constants';

const TitleBar = ({
  hide,
  titlePadding,
  title,
  Icon,
  iconSize,
  titleDescription,
  ...rest
}) => {
  return (
    <CapRow
      type="flex"
      align="middle"
      className={`${clsPrefix}-title-bar`}
      style={{
        padding: titlePadding,
      }}
      {...rest}
      data-testid="title-bar"
    >
      <Icon round={true} onClick={hide} iconSize={iconSize} />
      <span className={`${clsPrefix}-heading-text`}>{title}</span>
      <CapIcon type="beta" size="s" />
      <CapIcon
        type="close"
        className={`${clsPrefix}-close-btn`}
        onClick={hide}
        data-testid="close-btn"
      />
    </CapRow>
  );
};

export default TitleBar;
